<template>
  <div>
    <el-table
      ref="dataTable"
      :data="tableData"
      border
      style="width: 100%; min-height: 417px"
      size="mini"
      stripe
      row-key="id"
      :load="load"
      :lazy="lazy"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      v-loading="listLoading"
      highlight-current-row
      @selection-change="selectLine"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellClassName"
      @cell-click="tableCellClick"
      @expand-change="expandChange"
    >
      <!-- 多选框 -->
      <el-table-column
        v-if="selection"
        type="selection"
        width="55"
        :align="align"
      ></el-table-column>
      <el-table-column v-if="expand" type="expand">
        <template slot-scope="props">
          <slot name="expand" :data="props" />
        </template>
      </el-table-column>
      <!-- 文本数据渲染 -->
      <template v-for="item in tableHead">
        <el-table-column
          v-if="item.columnType === 'slot'"
          :prop="item.field"
          :label="item.label"
          :key="item.field"
          :width="item.width"
          :align="align"
        >
          <template slot-scope="scope">
            <slot :name="item.slotName" :data="scope" />
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :prop="item.field"
          :label="item.label"
          :key="item.field"
          :width="item.width"
          :align="align"
          :show-overflow-tooltip="item.tooltip"
        ></el-table-column>
      </template>
      <div class="no-message" slot="empty">
        <!-- <img src="~@/assets/pic/common/empty.png" alt="" /> -->
        <div class="info1">暂无内容</div>
      </div>
    </el-table>

    <pagination
      v-show="tableData.length > 0"
      :total="paginationData.total"
      @pagination="pageHandler"
      :page.sync="paginationData.current"
      :limit.sync="paginationData.pageSize"
    />
  </div>
</template>

<script>
import pagination from "@/components/Pagination";
export default {
  name: "e-table",
  components: { pagination },
  props: {
    tableHeadConfig: {
      type: Array,
      default: () => {
        return [];
      },
    },
    load: {
      type: Function,
      default: () => {
        return [];
      },
    },
    tableLoadData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableRowClassName: {
      type: Function,
      default: () => {
        return "";
      },
    },
    tableCellClassName: {
      type: Function,
      default: () => {
        return "";
      },
    },
    tableCellClick: {
      type: Function,
      default: () => {
        return "";
      },
    },
    align: {
      type: String,
      default: "center",
    },
    selection: {
      type: Boolean,
      default: false,
    },
    expand: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: "initial",
    },

    listLoading: {
      type: Boolean,
      default: false,
    },
    paginationData: {
      type: Object,
      default: () => {
        return { page: 1, limit: 10, total: 0 };
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    pageHandler() {
      console.log(this.paginationData);
      this.$emit("pageChange");
    },
    selectLine() {
      // if (
      //   this.$refs.dataTable.selection &&
      //   this.$refs.dataTable.selection.length > 0
      // ) {
      //   this.$emit("selectLine", this.$refs.dataTable.selection);
      // }
      this.$emit("selectLine", this.$refs.dataTable.selection);
    },
    expandChange (row, expandedRows) {
      console.log(row, expandedRows);
        this.$emit("expandChange", { row, expandedRows});
    }
  },
  computed: {
    tableData() {
      return this.tableLoadData;
    },
    tableHead() {
      return this.tableHeadConfig;
    },
  },
};
</script>
<style lang="scss" scoped>
// 点击的时候添加的class样式
.el-table__body tr.current-row > td {
  // background-color: #69A8EA !important;
  //   background-color: #1f2d3da1 !important;
  //   color: #fff;
}
.el-table {
  margin-bottom: 20px;
}

::v-deep.el-table .danger-row .el-table__cell {
  background: #fd9e9e !important;
}
::v-deep.el-table .warning-row .el-table__cell {
  background: oldlace !important;
}
::v-deep.el-table .success-row .el-table__cell {
  background: #f0f9eb !important;
}

::v-deep.el-table .success-row .el-table__cell {
  background: #f0f9eb !important;
}
// /deep/.el-table__empty-block {
//   height: 417px !important;
// }
// /deep/.el-table__body-wrapper {
//   height: auto !important;
// }
.no-message {
  height: 417px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i {
    display: inline-block;
    width: 98px;
    height: 98px;
    margin-bottom: 24px;
  }
  .info1 {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .info2 {
    font-size: 12px;
    font-weight: 400;
    color: #909399;
    line-height: 20px;
  }
}
</style>
